import cloneDeep from 'lodash/cloneDeep';
import apiService from 'src/utils/apiService';
import * as types from '../mutation-types';


// initial state
const state = {
  alertsList: [],
  alertGroupedByTickers: [],
};

// getters
const getters = {
};

// actions
const actions = {
  updateAlerts({ commit, state }, cb) { // eslint-disable-line
    return apiService.getAlerts().then((alerts) => {
      commit(types.UPDATE_ALERTS, alerts);
      cb && cb(); // eslint-disable-line
    });
  },
  getAlertsGroupedByTickers({ commit, state }, cb) { // eslint-disable-line
    return apiService.getAlertsGroupedByTickers().then((alerts) => {
      commit(types.SET_ALERTS_GROUPED_BY_TICKERS, alerts);
      cb && cb(); // eslint-disable-line
    });
  },
};

// mutations
const mutations = {
  [types.UPDATE_ALERTS](s, alerts) {
    s.alertsList = cloneDeep(alerts); // eslint-disable-line
  },
  [types.SET_ALERTS_GROUPED_BY_TICKERS](s, alerts) {
    s.alertGroupedByTickers = cloneDeep(alerts); // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/alerts.js